import { Component, OnInit} from '@angular/core';
import { NavController } from 'ionic-angular';
import { JobSearchComponent } from '../../job-search/job-search.component';

@Component({
  selector: 'sts-search-job',
  templateUrl: './search-job.component.html'
})
export class SearchJobComponent implements OnInit {
  jobSearchComponent: any = JobSearchComponent;
  searchText: String = "";

  constructor(public navCtrl: NavController) {

  }

  ngOnInit() {
  }

  jobSearch() {
    this.navCtrl.push(this.jobSearchComponent, {
      searchText: this.searchText
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/search-job/search-job.component.ts